import useNavModel, { RouterParamType } from '@/model/navModel'
import React, { useState } from 'react'
import { Contrast } from './contrast'
import { Mavb } from './mavb'
import { Button, Col, Row } from 'antd'
import { useInquiryContrastModel } from './inquiryContrastModel'
export default () => {
    const { getSelectedNavState } = useNavModel(() => [])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { handelSave } = useInquiryContrastModel(() => [])
    return (
        <>
            {detailsInfo && (
                <>
                    <Row justify="end">
                        <Col >
                            <Button className="mr-5" type="link" shape="round" onClick={handelSave}>
                                保存
                            </Button>
                        </Col>
                        
                    </Row>
                    <div className="flex justify-center" style={{ width: 'calc(100vw - 255px)' }}>
                        <Mavb {...detailsInfo} className="flex-1" />
                        <Contrast {...detailsInfo} type="one" className="flex-1" />
                        <Contrast {...detailsInfo} type="two" className="flex-1" />
                    </div>
                </>
            )}
        </>
    )
}
